// @flow
import { connect } from "react-redux";
import BlogDialog from "./view";
import BlogCard from "../blog-card";
import Dialog from "../dialog";
import { hideBlog } from "../state/blogs/actions";
import { getShowBlog } from "../state/blogs/reducer";

export default connect(
    state => ({
        blog: getShowBlog(state.blogs),
        BlogCard,
        Dialog
    }),
    dispatch => ({
        onHideBlog: () => dispatch(hideBlog())
    })
)(BlogDialog);



// WEBPACK FOOTER //
// ./src/blog-dialog/index.js